import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { PrivateDistributionListMember } from 'owa-persona';

export const editFavoritePrivateDistributionList = action(
    'editFavoritePrivateDistributionList',
    (
        favoriteId: string,
        newMembers: PrivateDistributionListMember[],
        newName: string,
        newNotes: string,
        actionSource: string
    ) =>
        addDatapointConfig(
            {
                name: 'EditFavoritePrivateDistributionList',
                customData: {
                    actionSource,
                },
            },
            {
                favoriteId,
                newMembers,
                newName,
                newNotes,
            }
        )
);
